"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourceHintLink = void 0;
var React = require("react");
/**
 * This code file exports a ResourceHintLink class that implements the AdditionalMeta interface. The class takes parameters and renders a <link> HTML element with those attributes.
 * The renderMetaElement method returns the JSX for the <link> element.
 * The purpose of this class is to create resource hints for the browser, which can improve the performance of the page by pre-resolving DNS lookups, establishing early connections to resources, and prioritizing fetching of resources.
 *
 * e.g. <link rel="preconnect" href="https://maps.googleapis.com" as="script" crossOrigin="anonymous">
 */
var ResourceHintLink = /** @class */ (function () {
    function ResourceHintLink(rel, href, as, type, crossOrigin, 
    // Please use fetchPriority sparingly as setting a high fetch priority for unnecessary scripts on the initial page load can reduce Largest Contentful Paint (LCP).
    fetchPriority) {
        this.rel = rel;
        this.href = href;
        this.as = as;
        this.type = type;
        this.crossOrigin = crossOrigin;
        this.fetchPriority = fetchPriority;
    }
    ResourceHintLink.prototype.renderMetaElement = function () {
        return (React.createElement("link", { rel: this.rel, href: this.href, as: this.as, type: this.type, crossOrigin: this.crossOrigin, 
            // @ts-ignore; fetchpriority is used on some browsers to manually indicate the priority of a resource
            // eslint-disable-next-line react/no-unknown-property
            fetchpriority: this.fetchPriority }));
    };
    return ResourceHintLink;
}());
exports.ResourceHintLink = ResourceHintLink;
//# sourceMappingURL=resource-hint-link.js.map